export default __webpack_public_path__ + "static/media/img-0581-iceland-half-face.a9f971ba.png";